import React from "react";

/**
 * BookingsTable — table of students who booked a post.
 *
 * Props:
 *   bookings — array of booking objects (or undefined if not yet loaded)
 */
function BookingsTable({ bookings }) {
  if (!bookings) {
    return <p className="text-muted">Klikk "Vis påmeldinger" for å laste data.</p>;
  }
  if (bookings.length === 0) {
    return <p>Ingen elever har meldt seg på ennå.</p>;
  }

  return (
    <table className="table table-sm table-striped">
      <thead>
        <tr>
          <th>Navn</th>
          <th>E-post</th>
          <th>Telefon</th>
          <th>Kjønn</th>
          <th>Aldersgruppe</th>
          <th>Tajweed-nivå</th>
          <th>Type</th>
          <th>Påmeldt</th>
        </tr>
      </thead>
      <tbody>
        {bookings.map((b) => (
          <tr key={b.id}>
            <td>{b.student_name}</td>
            <td>{b.student_email}</td>
            <td>{b.phone || "–"}</td>
            <td>{b.sex || "–"}</td>
            <td>{b.age_range}</td>
            <td>{b.tajweed_level}</td>
            <td>
              {b.is_member ? (
                <span className="badge bg-success">✅ Medlem</span>
              ) : (
                <span className="badge bg-secondary">Gjest</span>
              )}
            </td>
            <td>{new Date(b.created_at).toLocaleString("nb-NO")}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default BookingsTable;
